// src/components/firebase/auth.js
import { signInWithEmailAndPassword, signOut, getAuth, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { loginStart, loginSuccess, loginFailure, logout } from "../redux/authSlice";


// ✅ Login User
// src/firebase/auth.js
export const loginUser = (email, password) => async (dispatch) => {
  dispatch(loginStart());
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const firebaseUser = userCredential.user;

    const docRef = doc(db, "users", firebaseUser.uid);
    const docSnap = await getDoc(docRef);
    const role = docSnap.exists() ? docSnap.data().role : "user";

    const cleanedUser = {
      uid: firebaseUser.uid,
      email: firebaseUser.email,
      role,
    };

    dispatch(loginSuccess(cleanedUser));
    return { success: true, role }; // ✅ return result so component can act on it

  } catch (err) {
    console.error("Login error:", err);
    dispatch(loginFailure(err.code || err.message)); // ✅ dispatch failure
    return { success: false, error: err.code || err.message }; // ✅ return error
  }
};


export const checkUserSession = () => async (dispatch) => {
  const auth = getAuth();

  // Add debug log here to confirm the session is being checked
  console.log("Checking user session...");

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      // Add log to confirm if the user is found
      console.log("User found in session:", user);

      const userDoc = await getDoc(doc(db, "users", user.uid));
      const role = userDoc.exists() ? userDoc.data().role : "user";
      console.log("User role from Firestore:", role);

      dispatch(loginSuccess({ uid: user.uid, email: user.email, role }));
    } else {
      // Log if the user is not logged in
      console.log("No user found in session.");

      dispatch(logout());
    }
  });
};



// ✅ Logout User
export const logoutUser = async (dispatch) => {
  try {
    await signOut(auth);
    console.log("User logged out.");
    dispatch(logout()); // Dispatch logout action to clear user state
  } catch (error) {
    console.error("Logout error:", error.message);
    dispatch(loginFailure(error.message)); // Handle error during logout
  }
};
